import { FilterIdsValues } from 'shared/mui/Filter/hooks/useIdFilters';

import { OrdersListFilterFormValues } from '../OrdersList/OrdersListContent';

export const ID_FILTER_RESET_VALUES: FilterIdsValues = {
  merchantReference: [],
  id: [],
  providerReferenceId: [],
  anyId: [],
};

export const FILTER_RESET_VALUES: OrdersListFilterFormValues = {
  merchant: null,
  appliedDate: [null, null],
  amountPenny: {
    lte: null,
    gte: null,
  },
  currency: [],
  direction: null,
  gateway: [],
  provider: null,
  method: [],
  status: [],
  timezone: null,
  customer: null,
  'gateway.provider': null,
  orderProviderExternalError: {
    providerExternalError: {
      reason: null,
    },
  },
  matchRejectReason: null,
  orderExternalErrorReason: null,
};
